import { Timestamp } from ".";
import { IUser } from ".";

export interface IWorkspaceBase {
  name: string | null;
}

export interface IWorkspace extends IWorkspaceBase {
  id: string;
  owner: string;
  createdBy: string | null;
  createdAt?: Timestamp;
  lastActivityAt?: Timestamp;
}

export enum WorkspaceRole {
  Owner = "Owner",
  Administrator = "Administrator",
  OrderDraft = "OrderDraft",
  ReadOnly = "ReadOnly",
}

export interface IWorkspaceAccessBase {
  name: string;
  email: string;
  isApiKey: boolean;
  role: WorkspaceRole;
}

export interface IWorkspaceAccess {
  workspaceId: string;
  workspaceName: string | null;
  name: string;
  email: string;
  role: WorkspaceRole;
  isApiKey: boolean;
  createdBy: string | null;
  createdAt?: Timestamp;
}

export interface IUserWithWorkspaceAccess {
  user: IUser;
  workspaces: IWorkspaceAccess[];
}
